import React from "react";
const AuctionOffers = () => {
    return (
        <>
            {/* <!-- Offers --> */}
            <div className="_offers_auction_wrapper">
                <div className="_offers_auction_wrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="_Offers_border_wrap">
                                    <div className="_Offers_border_heading_txt">
                                        <p className="_Offers_border_heading">Offers</p>
                                    </div>

                                    <div className="_Offers_auction_table_wrap">
                                        <table className="table _Offers_border_table">
                                            <thead>
                                                <tr>
                                                    <th className="_Offers_border_table_th" scope="col">
                                                        Price</th>
                                                    <th className="_Offers_border_table_th" scope="col">USD
                                                        Price</th>
                                                    <th className="_Offers_border_table_th" scope="col">
                                                        Difference</th>
                                                    <th className="_Offers_border_table_th" scope="col">
                                                        Expiration</th>
                                                    <th className="_Offers_border_table_th" scope="col">From
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="_Offers_tr">
                                                    <td className="_Offers_auction_border_table_td _Offers_auction_border_table_td1">
                                                        <span className="_op">
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                width="16" height="24" fill="none"
                                                                viewBox="0 0 16 24">
                                                                <path fill="#6B8CEF" fill-rule="evenodd"
                                                                    d="M7.988.74v8.558l-6.332 2.83L7.988 9.3v7.43l-7.233-4.2L7.988.74Zm.002 0 7.234 11.79-7.234 4.2V9.3l6.333 2.828-6.333-2.83V.74Zm-.002 17.336v5.815L.75 13.877l7.238 4.2Zm.002 5.815v-5.816l7.234-4.198L7.99 23.891Z"
                                                                    clip-rule="evenodd" />
                                                            </svg>
                                                        </span>
                                                        2.52 ETH
                                                    </td>
                                                    <td className="_Offers_auction_border_table_td">$6402.84
                                                    </td>
                                                    <td className="_Offers_auction_border_table_td">29%
                                                        below</td>
                                                    <td className="_Offers_auction_border_table_td">7 min
                                                    </td>
                                                    <td
                                                        className="_Offers_auction_border_table_td _Offers_auction_border_table_td1 _font_width">
                                                        nftinitcom</td>
                                                </tr>

                                                <tr className="_Offers_tr">
                                                    <td className="_Offers_auction_border_table_td _Offers_auction_border_table_td1">
                                                        <span className="_op">
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                width="16" height="24" fill="none"
                                                                viewBox="0 0 16 24">
                                                                <path fill="#6B8CEF" fill-rule="evenodd"
                                                                    d="M7.988.74v8.558l-6.332 2.83L7.988 9.3v7.43l-7.233-4.2L7.988.74Zm.002 0 7.234 11.79-7.234 4.2V9.3l6.333 2.828-6.333-2.83V.74Zm-.002 17.336v5.815L.75 13.877l7.238 4.2Zm.002 5.815v-5.816l7.234-4.198L7.99 23.891Z"
                                                                    clip-rule="evenodd" />
                                                            </svg>
                                                        </span>
                                                        2.60 ETH
                                                    </td>
                                                    <td className="_Offers_auction_border_table_td">
                                                        $6606.11</td>
                                                    <td className="_Offers_auction_border_table_td">25%
                                                        below</td>
                                                    <td className="_Offers_auction_border_table_td">56
                                                        min</td>
                                                    <td
                                                        className="_Offers_auction_border_table_td _Offers_auction_border_table_td1">
                                                        nghiequyen</td>
                                                </tr>
                                                <tr className="_Offers_tr">
                                                    <td className="_Offers_auction_border_table_td _Offers_auction_border_table_td1">
                                                        <span className="_op">
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                width="16" height="24" fill="none"
                                                                viewBox="0 0 16 24">
                                                                <path fill="#6B8CEF" fill-rule="evenodd"
                                                                    d="M7.988.74v8.558l-6.332 2.83L7.988 9.3v7.43l-7.233-4.2L7.988.74Zm.002 0 7.234 11.79-7.234 4.2V9.3l6.333 2.828-6.333-2.83V.74Zm-.002 17.336v5.815L.75 13.877l7.238 4.2Zm.002 5.815v-5.816l7.234-4.198L7.99 23.891Z"
                                                                    clip-rule="evenodd" />
                                                            </svg>
                                                        </span>
                                                        2.52 ETH
                                                    </td>
                                                    <td className="_Offers_auction_border_table_td">
                                                        $6402.84
                                                    </td>
                                                    <td className="_Offers_auction_border_table_td">29%
                                                        below</td>
                                                    <td className="_Offers_auction_border_table_td">7 min
                                                    </td>
                                                    <td
                                                        className="_Offers_auction_border_table_td _Offers_auction_border_table_td1 _font_width">
                                                        nftinitcom</td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Offers --> */}
        </>
    )
}
export default AuctionOffers;
